import axios from 'axios';
import AuthService from 'lib/services/AuthService';

const instance = axios.create({
    baseURL: process.env.API_URL
});

export const updateAuthToken = (token) => {
    instance.defaults.headers.common['Authorization'] = `Bearer ${token}`
}

instance.interceptors.request.use(request => {
    request.headers['Authorization'] = `Bearer ${AuthService.getAccessToken()}`
    //console.log('%c Starting Request:::', 'background: #222; color: #bada55', request, getToken());
    return request
})

instance.interceptors.response.use(response => {
    //console.log('%c Response:::', 'background: #222; color: #bada55', response);
    return response
})

export default instance;